import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { useStepStatusSelector } from "Store/steps/stepsSelectors";
import { findStep } from "Store/steps/stepsUtils";
import { isDefined } from "Utils/functions";
import { NoProps } from "Utils/types";
import React from "react";
import { useRouteMatch } from "react-router";

export const ActiveStep = ({
  children,
}: React.PropsWithChildren<NoProps>): React.ReactElement => {
  const { steps, activeStepId } = useStepStatusSelector();
  const activeStep = findStep(steps, activeStepId);
  const stepRouteMatch = useRouteMatch(activeStep?.uri ?? "");

  const isOnActiveStep =
    isDefined(activeStep) &&
    isDefined(stepRouteMatch) &&
    stepRouteMatch.isExact;

  if (isOnActiveStep) {
    return <>{children}</>;
  }
  return <ThemedSpinner />;
};
